<!-- ===== LABEL ===== -->
<label *ngIf="label" class="wysiwyg-label">
  {{ label }}<span *ngIf="required" class="wysiwyg-required">*</span>
</label>

<div class="wysiwyg-wrapper" [class.disabled]="isDisabled">
  <!-- ===== TOOLBAR ===== -->
  <div class="wysiwyg-toolbar">

    <!-- History -->
    <div class="toolbar-group">
      <button type="button" class="toolbar-btn" title="Undo" (click)="editor.chain().focus().undo().run()" [disabled]="!toolbarState.canUndo">
        <mat-icon>undo</mat-icon>
      </button>
      <button type="button" class="toolbar-btn" title="Redo" (click)="editor.chain().focus().redo().run()" [disabled]="!toolbarState.canRedo">
        <mat-icon>redo</mat-icon>
      </button>
    </div>

    <div class="toolbar-divider"></div>

    <!-- Headings -->
    <div class="toolbar-group">
      <button type="button" class="toolbar-btn" title="Paragraph" [class.active]="toolbarState.paragraph" (click)="editor.chain().focus().setParagraph().run()">
        <mat-icon>subject</mat-icon>
      </button>
      <button *ngFor="let level of headingLevels" type="button" class="toolbar-btn toolbar-btn--text" [class.active]="toolbarState.headings[level]" [title]="'Heading ' + level" (click)="setHeading(level)">
        H{{ level }}
      </button>
    </div>

    <div class="toolbar-divider"></div>

    <!-- Basic Formatting -->
    <div class="toolbar-group">
      <button type="button" class="toolbar-btn" title="Bold" [class.active]="toolbarState.bold" (click)="editor.chain().focus().toggleBold().run()">
        <mat-icon>format_bold</mat-icon>
      </button>
      <button type="button" class="toolbar-btn" title="Italic" [class.active]="toolbarState.italic" (click)="editor.chain().focus().toggleItalic().run()">
        <mat-icon>format_italic</mat-icon>
      </button>
      <button type="button" class="toolbar-btn" title="Underline" [class.active]="toolbarState.underline" (click)="editor.chain().focus().toggleUnderline().run()">
        <mat-icon>format_underlined</mat-icon>
      </button>
    </div>

    <div class="toolbar-divider"></div>

    <!-- Text Alignment -->
    <div class="toolbar-group">
      <button type="button" class="toolbar-btn" title="Align Left" [class.active]="toolbarState.alignLeft" (click)="editor.chain().focus().setTextAlign('left').run()">
        <mat-icon>format_align_left</mat-icon>
      </button>
      <button type="button" class="toolbar-btn" title="Align Center" [class.active]="toolbarState.alignCenter" (click)="editor.chain().focus().setTextAlign('center').run()">
        <mat-icon>format_align_center</mat-icon>
      </button>
      <button type="button" class="toolbar-btn" title="Align Right" [class.active]="toolbarState.alignRight" (click)="editor.chain().focus().setTextAlign('right').run()">
        <mat-icon>format_align_right</mat-icon>
      </button>
      <button type="button" class="toolbar-btn" title="Justify" [class.active]="toolbarState.alignJustify" (click)="editor.chain().focus().setTextAlign('justify').run()">
        <mat-icon>format_align_justify</mat-icon>
      </button>
    </div>

    <div class="toolbar-divider"></div>

    <!-- Lists -->
    <div class="toolbar-group">
      <button type="button" class="toolbar-btn" title="Bullet List" [class.active]="toolbarState.bulletList" (click)="editor.chain().focus().toggleBulletList().run()">
        <mat-icon>format_list_bulleted</mat-icon>
      </button>
      <button type="button" class="toolbar-btn" title="Ordered List" [class.active]="toolbarState.orderedList" (click)="editor.chain().focus().toggleOrderedList().run()">
        <mat-icon>format_list_numbered</mat-icon>
      </button>
      <button type="button" class="toolbar-btn" title="Indent" (click)="editor.chain().focus().sinkListItem('listItem').run()">
        <mat-icon>format_indent_increase</mat-icon>
      </button>
      <button type="button" class="toolbar-btn" title="Outdent" (click)="editor.chain().focus().liftListItem('listItem').run()">
        <mat-icon>format_indent_decrease</mat-icon>
      </button>
    </div>

    <div class="toolbar-divider"></div>

    <!-- Blocks -->
    <div class="toolbar-group">
      <button type="button" class="toolbar-btn" title="Blockquote" [class.active]="toolbarState.blockquote" (click)="editor.chain().focus().toggleBlockquote().run()">
        <mat-icon>format_quote</mat-icon>
      </button>
      <button type="button" class="toolbar-btn" title="Hard Break" (click)="editor.chain().focus().setHardBreak().run()">
        <mat-icon>keyboard_return</mat-icon>
      </button>
    </div>

    <div class="toolbar-divider"></div>

    <!-- Link -->
    <div class="toolbar-group">
      <button type="button" class="toolbar-btn" title="Link" [class.active]="toolbarState.link" (click)="setLink()">
        <mat-icon>link</mat-icon>
      </button>
      <button type="button" class="toolbar-btn" title="Unlink" (click)="editor.chain().focus().unsetLink().run()" [disabled]="!toolbarState.link">
        <mat-icon>link_off</mat-icon>
      </button>
    </div>

    <div class="toolbar-divider"></div>

    <!-- Font Color -->
    <div class="toolbar-group">
      <mat-select class="toolbar-select" placeholder="Color" (selectionChange)="setFontColor($event.value)" title="Text Color">
        <mat-option *ngFor="let c of fontColors" [value]="c.value">
          <span class="color-dot" [style.background]="c.value || 'currentColor'"></span>
          {{ c.label }}
        </mat-option>
      </mat-select>
    </div>

    <!-- Highlight Color -->
    <div class="toolbar-group">
      <mat-select class="toolbar-select" placeholder="Highlight" (selectionChange)="setHighlight($event.value)" title="Highlight Color">
        <mat-option *ngFor="let h of highlightColors" [value]="h.value">
          <span class="color-dot" [style.background]="h.value"></span>
          {{ h.label }}
        </mat-option>
      </mat-select>
    </div>

    <div class="toolbar-divider"></div>

    <!-- Clear Formatting -->
    <div class="toolbar-group">
      <button type="button" class="toolbar-btn" title="Clear Formatting" (click)="editor.chain().focus().clearNodes().unsetAllMarks().run()">
        <mat-icon>format_clear</mat-icon>
      </button>
    </div>

    <!-- Extra toolbar actions provided by the host -->
    <ng-content select="[wysiwygToolbar]"></ng-content>

  </div>
  <!-- END TOOLBAR -->

  <!-- ===== EDITOR ===== -->
  <div class="wysiwyg-editor-area">
    <div #editorContainer></div>
  </div>

  <!-- ===== FOOTER ===== -->
  <div class="wysiwyg-footer">
    <span>{{ wordCountValue }} words</span>
    <span *ngIf="characterLimit > 0">{{ charCount }} / {{ characterLimit }} characters</span>
    <span *ngIf="characterLimit === 0">{{ charCount }} characters</span>
  </div>

</div>
